<template>
  <div class="events">
    <router-view />
    <SearchBar @search="handleSearchEvent" />
    <div class="content--main" v-if="events">
      <div class="row" v-if="events.length == 0">
        <div class="col-6 length-0">
          <span>There are no Events yet</span>
        </div>
      </div>
      <div class="row">
        <div class="col-4 event--list-wrapper">
          <div class="event--list" v-scroll="onScroll">
            <div v-for="(event, i) of events" :key="i">
              <Widget
                :widgets="event"
                @widgetClick="handleWidgetClick(i, event)"
                :class="i === activeIndex ? 'active' : ''"
                @mouseover.native="hoveredWidget.push(event.id)"
                @mouseleave.native="hoveredWidget.splice(1)"
                :style="{
                  backgroundColor: hoveredWidget.includes(event.id)
                    ? secondary
                    : '#fafafa',
                  transition: 'background-color 0.2s ease'
                }"
              >
                <div class="widget--avatar">
                  <img
                    v-if="event.featuredImage"
                    :src="event.featuredImage"
                    alt="event thumb"
                  />
                  <span
                    v-else
                    :style="{
                      backgroundColor: hoveredWidget.includes(event.id)
                        ? primary
                        : secondary,
                      color: hoveredWidget.includes(event.id) ? '#fff' : primary
                    }"
                    >{{ event.name[0] }}</span
                  >
                </div>
                <div class="widget--info">
                  <p class="mb-0">
                    {{ event.name }}
                  </p>
                  <p class="muted mb-0">
                    {{
                      parseDate(event.startDate, "YYYY-MM-DD") ==
                      parseDate(event.endDate, "YYYY-MM-DD")
                        ? parseDate(event.startDate, "MMM, DD. YYYY hh:mm A") +
                          " - " +
                          parseDate(event.endDate, "hh:mm A")
                        : parseDate(event.startDate, "MMM, DD. YYYY hh:mm A") +
                          " - " +
                          parseDate(event.endDate, "MMM, DD. YYYY hh:mm A")
                    }}
                  </p>
                </div>
              </Widget>
            </div>
          </div>
        </div>
        <div class="col-8 event--profile-wrapper">
          <template>
            <div class="event--profile">
              <WidgetDetails
                title="Event Details"
                :widgetOptions="widgetOptions"
                @editEvent="editEvent"
                @deactivateEvent="deactivateEvent"
                v-if="singleevent"
              >
                <div class="d-flex">
                  <div class="widget--avatar">
                    <img
                      v-if="singleevent.featuredImage"
                      :src="singleevent.featuredImage"
                      alt="event avatar"
                    />
                    <span v-else :style="{ backgroundColor: primary }">{{
                      singleevent.name[0]
                    }}</span>
                  </div>
                  <div class="widget--details-wrapper">
                    <h4>
                      {{ singleevent.name }}
                    </h4>
                    <p class="-muted">
                      <img
                        src="~@/assets/media/icons/calendar_muted.svg"
                        alt="event icon"
                        height="20"
                        width="20"
                      />
                      {{
                        parseDate(singleevent.startDate, "YYYY-MM-DD") ==
                        parseDate(singleevent.endDate, "YYYY-MM-DD")
                          ? parseDate(
                              singleevent.startDate,
                              "MMM, DD. YYYY hh:mm A"
                            ) +
                            " - " +
                            parseDate(singleevent.endDate, "hh:mm A")
                          : parseDate(
                              singleevent.startDate,
                              "MMM, DD. YYYY hh:mm A"
                            ) +
                            " - " +
                            parseDate(
                              singleevent.endDate,
                              "MMM, DD. YYYY hh:mm A"
                            )
                      }}
                    </p>
                    <div class="row">
                      <div class="col">
                        <p v-if="singleevent.description != null">
                          <img
                            src="~@/assets/media/icons/event_note.svg"
                            alt="event note icon"
                            height="20"
                            width="20"
                          />
                          {{ singleevent.description | decode | limit }}
                        </p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <template v-for="(meta, i) in singleevent.EventMeta">
                          <p v-if="meta.key != 'participants'" :key="i">
                            <img
                              src="~@/assets/media/icons/marker.svg"
                              alt="marker icon"
                              height="20"
                              width="20"
                            />
                            {{ meta.label }} : {{ meta.value }}
                          </p>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="row align-items-end justify-content-between widget--table-row mx-0"
                >
                  <div class="col px-0"><h4>Participants</h4></div>
                  <div class="col px-0 text-right">
                    <ActionButton
                      label="Add a participant"
                      :theme="{ primary, secondary, event, danger }"
                      class="mt-0 d-inline-block w-auto"
                      @customEvent="
                        handleAddEventParticipantClick({
                          modal: 'concierge-add-event-participant',
                          name: 'add-event-participant',
                          id: singleevent.id
                        })
                      "
                    />
                  </div>
                </div>
                <div class="row mx-0">
                  <div class="col" v-if="singleevent.EventMeta.length">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Company</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <template
                          v-for="(participant, i) in singleevent.EventMeta"
                        >
                          <tr v-if="participant.key == 'participants'" :key="i">
                            <td>
                              {{ jsonParsed(participant.value).name }}
                            </td>
                            <td>{{ jsonParsed(participant.value).email }}</td>
                            <td>{{ jsonParsed(participant.value).company }}</td>
                            <td>
                              <a
                                href="#"
                                @click="
                                  handleDeleteEventParticipantClick({
                                    id: participant.id,
                                    eventId: participant.eventId
                                  })
                                "
                              >
                                <img
                                  src="~@/assets/media/icons/remove.svg"
                                  alt="remove icon"
                                />
                              </a>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                  <div class="col mt-3 length-0" v-else>
                    <span>There are no event participants yet.</span>
                  </div>
                </div>
              </WidgetDetails>
            </div>
          </template>
        </div>
      </div>
    </div>
    <template v-else>
      <Spinner :theme="primary" />
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ActionButton from "@/components/ActionButton";
import SearchBar from "@/components/SearchBar";
import Widget from "@/modules/concierge/elements/Widget";
import Spinner from "@/components/Spinner";
import WidgetDetails from "@/modules/concierge/elements/WidgetDetails";
import moment from "@/helpers/moment";
import _ from "lodash";
import { socketSender } from "@/helpers/socket";

export default {
  name: "ConciergeEvents",
  components: {
    SearchBar,
    Widget,
    Spinner,
    WidgetDetails,
    ActionButton
  },
  data() {
    return {
      mainModule: this.$route.matched[0].name,
      activeIndex: 0,
      widgetOptions: [
        {
          icon: "edit",
          label: "Edit Details",
          method: "editEvent"
        },
        {
          icon: "delete",
          label: "Deactivate",
          method: "deactivateEvent"
        }
      ],
      loader: true,
      metas: [],
      participantMeta: [],
      eventMeta: [],
      hoveredWidget: [],
      action: ""
    };
  },
  computed: {
    events() {
      return this.$store.state.admin.events;
    },
    singleevent() {
      if (this.$store.state.admin.events) {
        return this.$store.state.admin.events[this.activeIndex];
      }
      return {};
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  },
  async created() {
    await this.$store.dispatch("EVENT_LIST_RESET", "");
    await this.$store.dispatch("EVENT_LIST_PAGINATE", "");
    if (this.$route.query.key) {
      let index = _.findIndex(this.events, o => {
        return o.id == this.$route.query.key;
      });
      await this.handleWidgetClick(index, this.events[index]);
    } else {
      if (this.events && this.events.length != 0) {
        await this.handleWidgetClick(0, this.events[0]);
      }
    }
  },
  methods: {
    ...mapActions({
      changeActiveTrail: "changeActiveTrail"
    }),
    ...mapGetters({
      getEvents: "getEvents"
    }),
    parseDate(date, format) {
      return moment(date).format(format);
    },
    handleWidgetClick(index, event) {
      const { name, id } = event;
      const { matched, path } = this.$route;
      this.activeIndex = index;
      this.changeActiveTrail([
        { name: "Home", link: matched[0].path },
        { name: "Events", link: path },
        { name: `${name}` }
      ]);
      this.hoveredWidget = [];
      this.hoveredWidget.push(id);
    },
    handleAddEventParticipantClick(params) {
      let { modal, name, id } = params;
      let singleRecord = this.singleevent;
      if (this.mainModule == "admin") {
        modal = "admin-events-page-add-event-participant";
      }
      this.$emit("showModal", {
        modal,
        name,
        id,
        singleRecord,
        hasBackdropEvent: false
      });
    },
    handleDeleteEventParticipantClick(param) {
      this.$swal
        .fire({
          title: "Are you sure you want to delete this participant?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        })
        .then(async result => {
          if (result.value) {
            await this.$store.dispatch("deleteEventMeta", param.id);
            this.activeIndex = this.activeIndex == 0 ? 0 : this.activeIndex;

            this.$toastr.success("Delete Participant success", "Success");

            await this.$store.dispatch("fetchEvents");
          }
        });
    },
    handleSearchEvent(searchTerm) {
      this.$store.dispatch("EVENT_LIST_RESET");
      if (searchTerm != null && searchTerm != "") {
        this.action = `search[name]=${searchTerm}`;
        this.$store.dispatch("EVENT_LIST_PAGINATE", this.action);
      } else {
        this.$store.dispatch("EVENT_LIST_PAGINATE", "");
      }
    },
    editEvent() {
      let modal = "concierge-events-add-event";
      if (this.mainModule == "admin") {
        modal = "admin-events-page-add-event";
      }
      let name = "edit-event";
      let singleRecord = this.singleevent;
      this.$emit("showModal", {
        modal,
        name,
        singleRecord,
        hasBackdropEvent: false
      });
    },
    deactivateEvent() {
      let pickedEventId = this.singleevent.id;
      this.$swal
        .fire({
          title: "Are you sure you want to deactivate this event?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          showLoaderOnConfirm: true,
          allowOutsideClick: () => !this.$swal.isLoading(),
          preConfirm: () => {
            return new Promise((resolve, reject) => {
              this.activeIndex =
                this.activeIndex == 0 ? 0 : this.activeIndex - 1;
              this.$store
                .dispatch("deleteEvent", pickedEventId)
                .then(() => {
                  /**
                   * SOCKET: Deactivate event
                   */
                  let logContent = `${this.$store.getters.getFullUser} deactivated the event named ${this.singleevent.name}`;
                  return socketSender("removeEvent", logContent);
                })
                .then(() => this.$store.dispatch("fetchEvents"))
                .then(() => {
                  resolve(true);
                })
                .catch(reject);
            });
          }
        })
        .then(async result => {
          if (result.value) {
            this.$toastr.success("Your changes are saved.", "Saved");
          }
        });
    },
    jsonParsed(value) {
      let participant = JSON.parse(`${value}`);
      return participant;
    },
    async onScroll(el, position) {
      let divScrollHeight = Math.floor(el.target.scrollHeight);
      let scrollCurrentHeight = Math.floor(
        position.scrollTop + el.target.offsetHeight
      );
      if (divScrollHeight === scrollCurrentHeight) {
        await this.$store.dispatch("EVENT_LIST_PAGINATE", this.action);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.events {
  padding: 0 15px;
  .content--main {
    height: calc(
      100vh - 274px
    ); /* height of viewport minus the sum of nav.header and <SearchBar/> */
    overflow-x: hidden;
    overflow-y: auto;
    padding-bottom: 20px;
    padding-top: 20px;
    & > .row {
      height: 100%;
      div[class^="col-"] {
        height: 100%;
        overflow: auto;
      }
    }
    .event {
      &--list {
        border-radius: 5px;
        overflow: auto;
        height: 100%;
      }
      &--profile {
        background-color: $gray-50;
        border-radius: 5px;
        max-height: 100%;
        overflow: auto;
        .widget--avatar {
          margin-right: 30px;
          span {
            align-items: center;
            background-color: $brand-primary;
            border-radius: 50%;
            color: $white;
            display: flex;
            font-family: "Gotham";
            font-size: $font-size-xl;
            font-weight: 500;
            height: 110px;
            justify-content: center;
            width: 110px;
          }
          img {
            border-radius: 50%;
            display: block;
            height: 110px;
            object-fit: cover;
            width: 110px;
          }
        }
        .widget--details-wrapper {
          h4 {
            color: $gray-900;
            font-size: $font-size-md;
            font-weight: 500;
            margin-bottom: 10px;
          }
          p {
            align-items: flex-start;
            display: flex;
            font-family: "Gotham Book";
            font-size: $font-size-sm;
            img {
              flex-shrink: 0;
              margin-right: 10px;
              height: 20px;
              width: 20px;
            }
            &.-muted {
              color: $gray-550;
            }
          }
        }
        .widget--table-row {
          border-bottom: 1px solid $gray-250;
          padding: 10px 0;
          h4 {
            color: $gray-900;
            font-size: $font-size-xs;
            font-weight: 500;
          }
        }
        .table {
          font-size: $font-size-sm;
          thead {
            th {
              color: $gray-900;
              font-weight: 500;
            }
          }
          tbody {
            td {
              color: $gray-900;
              font-family: "Gotham Book";
              &.participant--status {
                font-family: "Gotham";
                font-weight: 600;
                letter-spacing: 1px;
              }
              button {
                width: 25px;
                height: 25px;
                font-size: 0.875rem;
                line-height: 16px;
                padding: 0px;
              }
            }
          }
        }
      }
    }
    .length-0 {
      span {
        color: $gray-900;
        font-family: "Gotham Book";
        font-size: $font-size-sm;
        text-align: left;
      }
    }
  }
}
</style>
